import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles'
import classNames from 'classnames'
import Grid from '@material-ui/core/Grid'
import ScrollableAnchor, { configureAnchors } from 'react-scrollable-anchor'

import { Accordion, MediaContainer, Markdown } from '../components'
import { Heading3 } from '../styleguide'
import { NAVIGATION_HEIGHT } from '../layouts/Navigation'
import { HEADER_HEIGHT } from '../layouts/Header'
import {
  SUMMARY_BAR_HEIGHT,
  SUMMARY_BAR_BORDER_WIDTH
} from '../components/SummaryBar'

configureAnchors({
  offset: -(
    NAVIGATION_HEIGHT +
    HEADER_HEIGHT +
    SUMMARY_BAR_HEIGHT -
    SUMMARY_BAR_BORDER_WIDTH
  ),
  scrollDuration: 800
})

const styles = {
  containerStyle: {
    paddingTop: 20,
    paddingBottom: 40,
    borderBottom: '1px solid #d6d8db',
    maxWidth: 1200,
    marginLeft: 'auto',
    marginRight: 'auto'
  },
  noBorderStyle: {
    border: 'none'
  },
  headerContainerStyle: {
    flexBasis: 'auto', // IE 11 fix
    marginBottom: 20
  },
  headlineStyle: {
    marginBottom: 10
  }
}

class TopicSection extends Component {
  state = {
    activePanel: null
  }

  onActivePanelChange = activePanel => this.setState({ activePanel })

  render() {
    const {
      anchorId,
      headline,
      description,
      image,
      hotspots,
      isLastSection,
      classes: {
        containerStyle,
        headerContainerStyle,
        headlineStyle,
        noBorderStyle
      }
    } = this.props
    const { activePanel } = this.state

    return (
      <ScrollableAnchor id={anchorId}>
        <Grid
          container
          spacing={0}
          className={classNames(
            containerStyle,
            isLastSection && noBorderStyle,
            'topic-section-container'
          )}
        >
          <Grid item xs className={headerContainerStyle}>
            <Heading3 className={headlineStyle}>{headline}</Heading3>
            <Grid item xs md={8} className="markdown-description-container">
              <Markdown source={description} />
            </Grid>
          </Grid>

          <Grid container spacing={24} className="content-container">
            <Grid item xs={12} sm={8} className="content-item">
              <MediaContainer
                image={image}
                alt={headline}
                hotspots={hotspots}
                activePanel={activePanel}
                onHotspotClick={this.onActivePanelChange}
              />
            </Grid>

            <Grid item xs={12} sm={4} className="content-item">
              <Accordion
                panels={hotspots}
                activePanel={activePanel}
                onActivePanelChange={this.onActivePanelChange}
              />
            </Grid>
          </Grid>
        </Grid>
      </ScrollableAnchor>
    )
  }
}

export default withStyles(styles)(TopicSection)



// WEBPACK FOOTER //
// ./src/components/TopicSection.js